import axiosInstance from 'shared/services/api/axiosInstance';

/** One end user's agent profile for a period: totals, agents, runs, conversations, evals, feedback, properties. */
export async function getUserProfile({ teamId, distinctId, from, to }) {
  const params = { team_id: teamId };
  if (from) params.time_start = from;
  if (to) params.time_end = to;
  const { data } = await axiosInstance.get(
    `/agent-runs/users/${encodeURIComponent(distinctId)}/profile`,
    { params },
  );
  return data;
}
